var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['csv-upload-tab-item', { 'active': _vm.isActive }],on:{"click":_vm.setActiveTab}},[_c('img',{attrs:{"src":_vm.icon,"alt":"icon"}}),_vm._v(" "),_c('span',{staticClass:"csv-type"},[_vm._v(_vm._s(_vm.csvType))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d65a55d6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/custom-components/CsvUploadTabItem.vue
// module id = null
// module chunks = 